var exports = {
  "B": "xf61da738--89b22e--offers-list",
};

module.exports = exports;
